export default "__VITE_ASSET__Dq7rdu2S__"